export { SerialDatabaseAdapter, BatchDatabaseAdapter } from './adapter'
